export default __webpack_public_path__ + "static/media/photo--sm--140.601930aa.jpg";